import { useEffect, useState } from "react";
import Editor from "./Editor";
import ButtonLoader from "./ButtonLoader";

const ProjectAdditionalInformationForm = ({ project, onSubmit, isLoading, onCloseClicked }) => {
  const [value, setCurrentValue] = useState('');

  useEffect(() => {
    if (!project) return;

    setCurrentValue(project.additionalInformation);
  }, [project]);

  const handleSubmit = async () => {
    onSubmit(value);
  }

  return (
    <div className="bg-white rounded-lg border border-ase-blue w-[680px] pb-1">
      <div className="flex items-center justify-between text-lg bg-ase-blue text-white p-4 font-bold rounded-t-md">
        <p>Update additional information</p>

        <p
          onClick={onCloseClicked}
          className="font-bold cursor-pointer text-2xl"
        >
          X
        </p>
      </div>

      <div className="flex flex-col gap-4 p-4">
        <Editor value={value} setCurrentValue={setCurrentValue} />

        <button
          onClick={handleSubmit}
          className="ase-button-primary h-[48px] flex items-center justify-center"
        >
          {isLoading ? <ButtonLoader /> : 'Submit'}
        </button>
      </div>
    </div>
  )
}

export default ProjectAdditionalInformationForm;
